import Cookies from "js-cookie";

const FLASH_COOKIE_NAME = "flash";
const FLASH_COOKIE_CONVERTER = (value, name) => {
  // Rails escapes " " space characters with "+" instead of "%20", so we need to replace them here.
  if (name === "flash") {
    return decodeURIComponent(value.replace(/\+/g, "%20"));
  }

  return Cookies.converter.read(value, name);
};


/**
 * This function is necessary to clean up flash cookies after they are displayed to
 * prevent them from persisting and showing up again on subsequent page loads. It handles
 * subdomain scenarios by iteratively removing cookies at each domain level.
 *
 * For "sub.example.com", it removes the cookie from these domains (in order)
 * 1. sub.example.com
 * 2. example.com
 *
 * For "asdf.sub.example.com", it removes the cookie from these domains (in order)
 * 1. asdf.sub.example.com
 * 2. sub.example.com
 * 3. example.com
 */
const removeFlashCookie = () => {
  const hostParts = window.location.hostname.split(".");

  const hostLevels = hostParts.length - 1; // Minus 1 to exclude TLD from host levels.
  for (let i = 0; i < hostLevels; i++) {
    const domain = hostParts.slice(i).join(".");
    Cookies.remove(FLASH_COOKIE_NAME, { domain: domain });
  }

  Cookies.remove(FLASH_COOKIE_NAME);
};


const flash = (type, message) => {
  const flashContainerElement = document.querySelector(".gecko-flash-container");
  if (!flashContainerElement) {
    return console.error("Couldn't find '.gecko-flash-container'");
  }

  const flashElement = document.createElement("div");
  flashElement.classList.add("gecko-flash", "gecko-override-links", type || "notice");

  const contentElement = document.createElement("div");
  contentElement.classList.add("tw-flex-1");
  contentElement.innerHTML = message;

  const closeElement = document.createElement("i");
  closeElement.classList.add("close", "fa", "fa-times");
  closeElement.onclick = flashElement.remove.bind(flashElement);

  flashElement.appendChild(contentElement);
  flashElement.appendChild(closeElement);

  flashContainerElement.appendChild(flashElement);
};


export const initializeFlashMessages = () => {
  window.addEventListener("load", () => {
    try {
      const flashMessages = Cookies.withConverter(FLASH_COOKIE_CONVERTER).getJSON(FLASH_COOKIE_NAME);
      Array.from(flashMessages).forEach(([type, message]) => flash(type, message));
    } catch (e) {
      console.error(`Failed to initialize flash messages: ${e}`);
    }

    removeFlashCookie();
  });
};
